/* eslint-disable react/require-default-props */
import clsx from 'clsx';
import React from 'react';

interface Props extends React.HTMLAttributes<HTMLElement> {
  variant?:
    | 'title1'
    | 'title2'
    | 'h1'
    | 'h2'
    | 'h3'
    | 'subtitle'
    | 'body'
    | 'light'
    | 'h4'
    | 'h5'
    | 'legal'
    | 'xl'
    | '2xl';
  children?: any;
  isLoading?: boolean;
}

const variantsMapping = {
  '2xl': 'h1',
  body: 'p',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  legal: 'p',
  light: 'p',
  subtitle: 'h4',
  title1: 'h1',
  title2: 'h1',
  xl: 'h1',
};

const variantSizeMapping = {
  body: '22px',
  h1: '42px',
  h2: '30px',
  h3: '24px',
  h4: '24px',
  h5: '14px',
  legal: '22px',
  light: '22px',
  subtitle: '24px',
  xl: '42px',
};

/** @deprecated */
const Typography: React.FunctionComponent<Props> = React.forwardRef<
  HTMLParagraphElement | HTMLHeadingElement,
  Props
>(
  (
    {
      className,
      children = null,
      isLoading = false,
      variant = 'body',
      ...other
    }: Props,
    ref
  ) => {
    const Component = React.createElement(
      variantsMapping[variant || 'body'],
      {
        className: clsx(`typography--variant-${variant}`, className),
        ref,
        ...other,
      },
      children
    );

    const Skeleton = React.createElement(
      'div',
      {
        className: clsx(`py-[2px] w-2/5`, className),
        style: {
          height: variantSizeMapping[variant || 'body'],
        },
      },
      <div
        className={clsx('h-full w-full animate-pulse rounded bg-gray-10 p-1')}
      />
    );

    return isLoading ? Skeleton : Component;
  }
);

export default Typography;
